<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['DB']['CSO']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['AGT']}}:</span>
                                <customtreeselect :multiple="false"
                                            :options="ddAgentList"
                                            :auto-load-root-options="convertToBool(searchAgent)"
                                            :disable-branch-nodes="true"
                                            :defaultExpandLevel="Infinity"
                                            @input="selectAgentOptions"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['U']}} :</span>
                                <CInput size="sm" :value="searchUsername" @change="v => searchUsername = v"></CInput>
                            </div>
                        </div>
                        <div class=' searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage['BTN']['SR']}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['DB']['CSOL']}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['GL']['NO']}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)">{{this.getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['U']}}<i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['LLTS']}} / {{this.getLanguage['MEM']['LLIP']}}<i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['LD']}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['GL']['NO']}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)">{{this.getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['U']}}<i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['LLTS']}} / {{this.getLanguage['MEM']['LLIP']}}<i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['LD']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_CSList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_CSList">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit) && isSENS == 1 && data.AGI != curAGI"></td>
                            <td v-else-if="checkModuleAccess2(constAccessType.edit) && isSENS == 1 && data.AGI == curAGI">
                                <span id="actionBtnCol">
                                    <div class="custom-tooltip">
                                        <i class="cil-account-logout" @click='LogoutMember(data)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["L"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td v-else-if="checkModuleAccess2(constAccessType.edit)">
                                <span id="actionBtnCol">
                                    <div class="custom-tooltip">
                                        <i class="cil-account-logout" @click='LogoutMember(data)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["L"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>
                                <span class="grid-line">{{ data.GN }}</span>
                            </td>
                            <td>
                                <span class="grid-line">
                                    {{data.U}}
                                </span>
                            </td>
                            <td>
                                <span class="grid-line">{{ formatDateTime(data.LLTS,"YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</span>
                                <span class="grid-line"><span class="grid-line"><a target="_blank" :href="checkIpAddress(data.LLIP)">{{data.LLIP}}</a></span></span>
                            </td>
                            <td>
                                <span class="grid-line">{{ getLoginDuration(data.LLTS, data.CD) }}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC','getUserInfo','checkModuleAccess']),
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_Advanced: false,
                str_tableSortBy: "I", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                // dropdown value
                ddAgentList: null,
                // search fields
                searchAgent: null,
                searchUsername: null,
                searchCurrency: null,

                arr_CSList: [],
                ddMemberList: [],
                constAccessType: constAccessType,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            getDevice(data) {
                if (data == 1) {
                    return this.getLanguage['DEV']['M'];
                }
                else {
                    return this.getLanguage['DEV']['D'];
                }
            },
            renderLoginDetails(data, isToolTipsText) {
                if (typeof data.LB === 'string') {
                    data.LB = JSON.parse(data.LB);
                }
                if (data.IM == 1 && data.LB != null && isToolTipsText == 0) {
                    var details = "";
                    if (data.LB.Browser != "unknown") {
                        details += data.LB.Browser;
                    }
                    if (data.LB.MobileDevice != "unknown") {
                        details += " " + data.LB.MobileDevice;
                    }
                    else if (data.LB.MobileDeviceManufacturer != "unknown") {
                        details += " " + data.LB.MobileDeviceManufacturer;
                    }
                    return details;
                }
                else if (data.IM == 0 && data.LB != null && isToolTipsText == 0) {
                    return data.LB.Browser;
                }
                else if (data.LB != null && isToolTipsText == 1) {
                    return data.LB.UserAgent;
                }
                return "-";
            },
            getLoginDuration(loginDateTime, currentTime) {
                let d = (new Date(currentTime)) - (new Date(loginDateTime));
                let W = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
                let DDAY = Math.floor(d / 1000 / 60 / 60 / 24 - W * 7);
                let DHR = Math.floor(d / 1000 / 60 / 60 - W * 7 * 24 - DDAY * 24);
                let DMT = Math.floor(d / 1000 / 60 - W * 7 * 24 * 60 - DDAY * 24 * 60 - DHR * 60);
                let DSC = Math.floor(d / 1000 - W * 7 * 24 * 60 * 60 - DDAY * 24 * 60 * 60 - DHR * 60 * 60 - DMT * 60);
                let t = {};
                ['DDAY', 'DHR', 'DMT', 'DSC'].forEach(q => { if (eval(q) > 0) { t[q] = eval(q); } });

                var dateKey = Object.keys(t);
                var temp = ""
                for (var i = 0; i < dateKey.length; i++) {
                    temp += t[dateKey[i]] + " ";
                    temp += this.getLanguage['MEM'][dateKey[i]] + " ";
                }
                return temp;
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.MTBC) {
                        bgColor = data.MTBC;
                    }

                    if (data.MTC) {
                        textColor = data.MTC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getCSOnlineList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getCSOnlineList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getCSOnlineList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            loadAgentOptions() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddAgentList = d.dropdownlist;
                                var at = 0;
                                at = that.ddAgentList[0].id.split("-")[0];
                                if (at == 3 && that.dd_agentgroup.length < 2) {
                                    that.searchAgent = that.ddAgentList[0].id;
                                }
                            }
                            else {
                                that.ddAgentList = null;
                            }

                            //callback();
                        });
                
                
            },
            selectAgentOptions(value, instanceId) {
                if (value) {
                    this.setSearchCriteriaAGI(value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }
            },
            checkIpAddress(ip) {
                if (ip) {
                    return `https://whatismyipaddress.com/ip/${ip}`;
                    //return `https://whatismyipaddress.com/ip/${ip}`;
                }
                else {
                    return '#';
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = 0;
                    if (this.searchAgent) {
                        agi = this.searchAgent.split("-")[1];
                    }
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/agac/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            getCSOnlineList() {
                this.bool_fullLoading = true;
                var that = this;
                var agentGId = null;
                if (this.searchAgent) {
                    var agentList = this.searchAgent.split("-");
                    agentGId = agentList[agentList.length - 1];
                }

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                if (agentGId) {
                    path += "&f.AGI=" + agentGId;
                }

                if (this.searchUsername) {
                    path += "&f.U=" + this.searchUsername;
                }
                if (this.searchCurrency) {
                    path += "&f.CI=" + this.searchCurrency;
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }
                this.getDataApi(`/api/agt/csol?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_CSList = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
            },
            LogoutMember(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["LOA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["CONFIRM"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            I: data.I,
                            AGI: data.AGI,
                        };

                        this.postDataApi(`/api/agt/logoutcs`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getCSOnlineList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('CSO', 'DASH', type);
            },
        },
        created() {
            this.$parent.showSubMenu = 'DASH';
            this.$parent.showActiveMenu = 'DASH.CSO';
            this.searchAgent = this.$route.query.agi;
            this.searchCurrency = this.$route.query.ci;
            this.loadAgentOptions();
            this.getCSOnlineList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        watch: {
            getLanguage() {
                this.getCSOnlineList();
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Agent/CSOnline.vue